import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sbpro-cotizaciones',
  templateUrl: './cotizaciones.component.html',
  styleUrls: ['./cotizaciones.component.scss']
})
export class CotizacionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
